import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'fileSize',
  standalone: true
})
export class FileSizePipe implements PipeTransform {
  transform(bytes: number | string, decimals: number): string {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(+bytes) / Math.log(k))
    return `${parseFloat((+bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }
}
